import React from "react";
const AggrementPage = () => {
  return (
    <>
      <h3>Aggrement Page</h3>
    </>
  );
};
export default AggrementPage;
